<template>
  <div>
    <b-card class="my-3" footer-bg-variant="transparent">
      <b-card header="Parâmetro Data do Pagamento" header-tag="header">
        <b-form inline>
          <div class="p-0 mb-3 col-12 d-md-flex">
            <label class="mr-sm-1 col-md-2 p-0" for="nome_completo">Ano</label>
            <b-form-select
              id="ano"
              @change="alteraDados"
              :disabled="parametro.id != null"
              v-model="$v.parametro.ano.$model"
              :class="$v.parametro.ano.$error ? ` is-invalid` : ``"
              :options="optionsAnoReferencia"
            >
            </b-form-select>
          </div>
          <div class="p-0 mb-3 col-12 d-md-flex">
            <label class="mr-sm-1 col-md-2 p-0" for="nome_completo">Mês</label>
            <b-form-select
              id="mes"
              @change="alteraDados"
              :disabled="parametro.id != null"
              v-model="$v.parametro.mes.$model"
              :class="$v.parametro.mes.$error ? ` is-invalid` : ``"
              :options="optionsMesReferencia"
            >
            </b-form-select>
          </div>
          <div class="p-0 mb-3 col-12 d-md-flex">
            <label class="mr-sm-1 col-md-2 p-0" for="nome_completo"
              >Data do Pagamento</label
            >
            <b-form-input
              id="data-pagamento"
              type="date"
              :max="'9999-12-31'"
              v-model="$v.parametro.data_pagamento.$model"
              :class="$v.parametro.data_pagamento.$error ? ` is-invalid` : ``"
            ></b-form-input>
          </div>
        </b-form>
      </b-card>
      <template v-slot:footer>
        <b-row>
          <b-col class="text-left">
            <b-button
              variant="outline-secondary"
              @click.prevent="voltar"
              title="Voltar"
            >
              <font-awesome-icon
                :icon="['fas', 'arrow-left']"
                title="Voltar"
                class="mr-1"
              />
              Voltar
            </b-button>
          </b-col>
          <b-col class="text-right">
            <b-button variant="success" @click.prevent="salvar" title="Salvar">
              <font-awesome-icon
                :icon="['fas', 'save']"
                title="Salvar"
                class="mr-1"
              />
              Salvar
            </b-button>
          </b-col>
        </b-row>
      </template>
    </b-card>
  </div>
</template>

<script>
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import ParametrosPagamento from "../../../models/ParametrosPagamento";

export default {
  data() {
    return {
      max_data_pagamento: null,
      parametro: new ParametrosPagamento(),
      formAlterado: false,
      optionsAnoReferencia: [],
      optionsMesReferencia: [
        { value: null, text: "Selecione um mês" },
        { value: 1, text: "Janeiro" },
        { value: 2, text: "Fevereiro" },
        { value: 3, text: "Março" },
        { value: 4, text: "Abril" },
        { value: 5, text: "Maio" },
        { value: 6, text: "Junho" },
        { value: 7, text: "Julho" },
        { value: 8, text: "Agosto" },
        { value: 9, text: "Setembro" },
        { value: 10, text: "Outubro" },
        { value: 11, text: "Novembro" },
        { value: 12, text: "Dezembro" },
      ],
      acao: null,
      hoje: moment().format("YYYY-MM-DD"), //Dia de hoje
      mesAtual: moment(this.hoje).format("YYYY-MM"),
    };
  },

  validations: {
    parametro: {
      ano: {
        required,
      },

      mes: {
        required,
      },

      data_pagamento: {
        required,
      },
    },
  },

  methods: {
    alteraDados() {
      this.formAlterado = true;
    },

    obter(id) {
      return this.$api
        .get(`parametros-pagamento/${id}`)
        .then((response) => {
          if (response.status == 200) {
            this.parametro = new ParametrosPagamento(response.data.dados);
          }
        })
        .catch((error) => {
          if (error.response.data) {
            this.$helpers.showToast(
              this,
              "Erro",
              error.response.data.message,
              "danger"
            );
          }
        });
    },

    editar() {
      this.$api
        .put(`parametros-pagamento/${this.parametro.id}`, this.parametro)
        .then((response) => {
          if (response.status === 201) {
            this.parametro = new ParametrosPagamento(response.data.dados);
            this.formAlterado = false;
            this.$helpers.showToast(
              this,
              "Sucesso",
              response.data.message,
              "success"
            );
          }
        })
        .catch((error) => {
          if (error.response.data) {
            this.$helpers.showToast(
              this,
              "Erro",
              error.response.data.message,
              "danger"
            );
          }
        });
    },

    incluir() {
      this.$api
        .post("parametros-pagamento", this.parametro)
        .then((response) => {
          if (response.status === 201) {
            this.parametro = new ParametrosPagamento(response.data.dados);
            this.formAlterado = false;
            this.$helpers.showToast(
              this,
              "Sucesso",
              response.data.message,
              "success"
            );
            this.$router.push(
              "/admin/parametros-pagamento/" + this.parametro.id
            );
          }
        })
        .catch((error) => {
          if (error.response.data) {
            this.$helpers.showToast(
              this,
              "Erro",
              error.response.data.message,
              "danger"
            );
          }
        });
    },

    salvar() {
      let mesReferencia = moment([
        this.parametro.ano,
        this.parametro.mes - 1,
      ]).format("YYYY-MM");

      let mesAnoDataPagamento = moment(this.parametro.data_pagamento).format(
        "YYYY-MM"
      );

      if (mesReferencia < this.mesAtual) {
        this.$helpers.showToast(
          this,
          "Erro",
          "Não é possivel cadastrar parâmetros para mês anterior ao ano corrente.",
          "danger"
        );
        return;
      }

      if (mesAnoDataPagamento != mesReferencia) {
        this.$helpers.showToast(
          this,
          "Erro",
          "A data do pagamento deve ser uma data dentro do mês e ano informados.",
          "danger"
        );
        return;
      }

        if ( this.hoje >= this.parametro.data_pagamento) {
          this.$helpers.showToast(
            this,
            "Erro",
            "A data do pagamento deve ser maior que a data atual.",
            "danger"
          );
          return;
      }

      this.$v.$touch();
      if (!this.$v.$invalid) {
        if (this.parametro.id === null) {
          this.incluir();
        } else {
          this.editar();
        }
      }
    },

    obterDataPagamento() {
      return this.$api
        .get(`parametros-pagamento/data-pagamento`)
        .then((response) => {
          if (response.status == 200) {
            this.max_data_pagamento =
              response.data.dados.dataPagamento.data_pagamento;
          }
        })
        .catch((error) => {
          if (error.response.data) {
            this.$helpers.showToast(
              this,
              "Erro",
              error.response.data.message,
              "danger"
            );
          }
        });
    },

    voltar() {
      if (this.formAlterado) {
        this.$helpers.confirmaVoltar(this).then((confirmado) => {
          if (confirmado) {
            this.$router.push({ name: "parametrosPagamento" });
          }
        });
      } else {
        this.$router.push({ name: "parametrosPagamento" });
      }
    },

    setNovoRegistro() {
      //Ano Referencia
      let anoCorrente = new Date().getFullYear();
      this.optionsAnoReferencia.push(anoCorrente);
      this.optionsAnoReferencia.push(anoCorrente + 1);
    },

    setRegistroExistente() {
      //Ano Referencia
      this.optionsAnoReferencia.push(this.parametro.ano);
    },

    async start() {
      if (this.$route.params.id === "new") {
        this.acao = "new";
        this.parametro = new ParametrosPagamento();
        this.setNovoRegistro();
      } else {
        this.acao = "edit";
        await this.obter(this.$route.params.id);
        this.setRegistroExistente();
      }
    },
  },

  mounted() {
    this.start();
    this.obterDataPagamento();
  },
};
</script>


